/** User profile helpers — aligned with mg-android SocialArticleMappers.kt */

export const USER_PROFILE_FILTER_GAMES = 1;
export const USER_PROFILE_FILTER_COLLECTIONS = 2;
export const USER_PROFILE_FILTER_TOPICS = 3;

export const TRACE_TYPE_USER = 3;

const hasNonEmptyLinkIds = ids => {
  if (!Array.isArray(ids)) return false;
  return ids.some(id => {
    if (id == null) return false;
    if (typeof id === "number") return id !== 0;
    if (typeof id === "string") {
      const text = id.trim();
      return text.length > 0 && text !== "0";
    }
    return true;
  });
};

export const postHasLinkedGames = item => {
  if (Array.isArray(item?.games) && item.games.length > 0) return true;
  return hasNonEmptyLinkIds(item?.gameIds);
};

export const postHasLinkedCollections = item => {
  if (Array.isArray(item?.collections) && item.collections.length > 0) {
    return true;
  }
  return hasNonEmptyLinkIds(item?.collectionIds);
};

export const postMatchesUserProfileFilter = (item, filterIndex) => {
  switch (filterIndex) {
    case USER_PROFILE_FILTER_GAMES:
      return postHasLinkedGames(item);
    case USER_PROFILE_FILTER_COLLECTIONS:
      return postHasLinkedCollections(item);
    case USER_PROFILE_FILTER_TOPICS:
      return !postHasLinkedGames(item) && !postHasLinkedCollections(item);
    default:
      return false;
  }
};

export const firstLinkedGameId = item => {
  const fromGames = item?.games?.[0]?.id;
  if (fromGames != null && Number(fromGames) > 0) {
    return Number(fromGames);
  }
  const fromIds = item?.gameIds?.[0];
  const num = Number(fromIds);
  return Number.isFinite(num) && num > 0 ? num : 0;
};

export const firstLinkedGameName = (item, fallback = "") =>
  item?.games?.[0]?.name || fallback;

export const firstLinkedCollectionId = item => {
  const fromCollections = item?.collections?.[0]?.id;
  if (fromCollections != null && Number(fromCollections) > 0) {
    return Number(fromCollections);
  }
  const fromIds = item?.collectionIds?.[0];
  const num = Number(fromIds);
  return Number.isFinite(num) && num > 0 ? num : 0;
};

export const firstLinkedCollectionName = (item, fallback = "") =>
  item?.collections?.[0]?.name || fallback;

/** Extract unique linked collections from posts when API list is empty. */
export const extractLinkedCollectionsFromPosts = posts => {
  const seen = new Set();
  const result = [];
  (posts || []).forEach(post => {
    (post?.collections || []).forEach(link => {
      const id = Number(link?.id);
      if (!Number.isFinite(id) || id <= 0 || seen.has(id)) return;
      seen.add(id);
      result.push({
        id,
        collectionName: link?.name || "",
        collectionIntro: String(post?.content || "")
          .replace(/<[^>]*>/g, "")
          .trim()
          .slice(0, 120),
        collectionIcon: "",
        gameSize: 0,
      });
    });
  });
  return result;
};

export const resolveUserDisplayName = (data, fallback = "") => {
  return (
    data?.nickname ||
    data?.username ||
    data?.name ||
    fallback ||
    ""
  ).trim();
};
